// App.jsx
import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline, Container, Box } from "@mui/material";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Navbar from "./components/Navbar";
import MainForm from "./components/MainForm";
import LoginForm from "./components/LoginForm";
import Accounts from "./components/Accounts";
import Company from "./components/Company";
import Cards from "./components/Cards";
import Order from "./components/Orders";
import OrderDetails from "./components/OrderDetails";

const theme = createTheme({
  palette: {
    primary: {
      main: "#E64833",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#333333",
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 10,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          backgroundColor: "#fafafa",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
  },
});

const isLoggedIn = () => {
  return localStorage.getItem("token") !== null;
};

function App() {
  return (
   <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ overflowX: 'hidden', overflowY: 'auto', minHeight: '100vh' }}>
        <Router>
          {isLoggedIn() && <Navbar />}
          <Routes>
            <Route path="/login" element={<LoginForm />} />
            <Route
              path="/"
              element={isLoggedIn() ? <MainForm /> : <Navigate to="/login" />}
            />
            <Route
              path="/accounts"
              element={isLoggedIn() ? <Accounts /> : <Navigate to="/login" />}
            />
             <Route
              path="/company"
              element={isLoggedIn() ? <Company /> : <Navigate to="/login" />}
            />
            <Route
              path="/cards"
              element={isLoggedIn() ? <Cards /> : <Navigate to="/login" />}
            />
             <Route
              path="/order"
              element={isLoggedIn() ? <Order /> : <Navigate to="/login" />}
            />
            <Route
              path="/order-detail"
              element={isLoggedIn() ? <OrderDetails /> : <Navigate to="/login" />}
            />
          </Routes>
        </Router>
      </Box>
    </ThemeProvider>
  );
}

export default App;